import { render, staticRenderFns } from "./IndividualRegisteredCourses.vue?vue&type=template&id=517523d5&scoped=true&"
import script from "./IndividualRegisteredCourses.vue?vue&type=script&lang=js&"
export * from "./IndividualRegisteredCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517523d5",
  null
  
)

export default component.exports